import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { DashboardResponse, Forms, Product } from '@app/modules/events/models/dashboard.model'

@Component({
  selector: 'ngx-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
  imports: [CommonModule]
})
export class ProductsComponent {
  @Input() dashboardData: DashboardResponse

  getProductSales(productId: number): number {
    const product = this.dashboardData?.products.find((p: Product) => p.id === productId)
    return product ? this.dashboardData?.gross_sales_by_product[productId] : 0
  }

  getFormsBySales(formId: number): number {
    if (this.dashboardData?.forms) {
      const form = this.dashboardData?.forms.find((f: Forms) => f?.id === formId)
      return form ? this.dashboardData?.gross_sales_by_form[formId] : 0
    }
    return 0
  }

  getProgressBarWidth(product: Product): number {
    const sales = this.getProductSales(product.id)
    const percentage = (sales / product?.max_quantity) * 100
    return percentage > 100 ? 100 : percentage
  }

  getProgressBarWidthForForms(form: Forms): number {
    if (!form.maximum_registrations) return 0
    const sales = this.getFormsBySales(form?.id)
    const percentage = (sales / form?.maximum_registrations) * 100
    return percentage > 100 ? 100 : percentage
  }

  getPercentage(product: Product): number {
    const sales = this.getProductSales(product.id)
    if (sales === 0) return 0
    return Math.round((sales / product.max_quantity) * 100)
  }

  getFormPercentage(form: Forms): number {
    const sales = this.getFormsBySales(form?.id)
    const maxRegistrations = form?.maximum_registrations || 0
    if (maxRegistrations === 0) return 0
    return Math.round((sales / form?.maximum_registrations) * 100)
  }
}
